<template>
  <Popup :width="width" :closePopupEvent="closePopupCB">
    <h6 slot="header">{{header}}</h6>
    <div v-if="!showSuccessMessage" class="session-exp-popup">
      <p class="enter-your-email-id">Enter your email id to reset password</p>
      <FormError v-show="formError" :message="formError" class="rst-pass-form-error" />
      <div class="reset-pass-form popup-form">
        <form @submit.prevent="resetPasswordCB" autocomplete="off">
          <input autocomplete="false" name="hidden" type="text" style="display:none;" />
          <div class="vlt-input-group">
            <label class="email-adress-label">Email Address</label>
            <input
              id="userEmail"
              type="email"
              v-model="userEmail"
              ref="userEmail"
              class="email-address"
              maxlength="128"
            />
            <p class="error-message">{{ userEmailError }}</p>
          </div>

          <Loading v-show="showLoading" />
          <div class="reset-btn">
            <button type="submit" class="btn-lg-primary" ref="loginBtnSubmit">Request</button>
          </div>
        </form>
      </div>
    </div>
    <div v-else class="success-style">
      <h5>{{ showSuccessMessage }}</h5>
    </div>
  </Popup>
  <!-- <div  class="rest-popup">
    <div class="popup-box" :style="{ width }" ref="popupBox">
      <div class="box-header">
        <slot name="header"><h6>{{ header }}</h6></slot>
        <img src="@/assets/icons/ico-close-dark.svg" alt="closes" class="header-close" @click="closePopupEvent()">
        <div class="clearfix"></div>
      </div>
      <div v-if="!showSuccessMessage" class="session-exp-popup">
          <p class="enter-your-email-id">Enter your email id to reset password</p>
          <FormError
          v-show="formError"
          :message="formError"
          class="rst-pass-form-error" />
          <div class="reset-pass-form popup-form">
            <form
              @submit.prevent="resetPasswordCB"
              autocomplete="off">
              <input
                autocomplete="false"
                name="hidden"
                type="text"
                style="display:none;">
              <div class="vlt-input-group">
                <label class="email-adress-label">Email Address</label>
                <input 
                  id="userEmail"
                  type="email"
                  v-model="userEmail"
                  ref="userEmail"
                   class="email-address">
                  <p class="error-message">{{ userEmailError }}</p>
              </div>

              <Loading v-show="showLoading" />
                <div class="reset-btn">
                  <button
                    type="submit"
                    class="btn-lg-primary"
                    ref="loginBtnSubmit">
                    Request
                  </button>
                </div>
            </form>
          </div>
      </div>
      <div v-else class="success-style">
      <h5>{{ showSuccessMessage }}</h5>  
      </div>      
    </div>
    <div class="popup-overlay" ><span></span></div>    
  </div>-->
</template>

<script>
import Popup from "@/components/Slots/Popup.vue";
import Loading from "@/components/Templates/Loading.vue";
import { mapGetters, mapMutations, mapActions } from "vuex";
import FormError from "@/components/Templates/FormError.vue";
import Utility from "@/mixins/Utility";

export default {
  name: "PopupResetPassword",
  props: {
    closePopupCB: {
      type: Function
    }
  },
  data() {
    return {
      width: "35%",
      userEmail: "",
      classValidateEmail: "",
      showLoading: false,
      formError: null,
      userEmailError: "",
      showSuccessMessage: null,
      header: "Forgot Password?"
    };
  },
  components: {
    Popup,
    Loading,
    FormError
  },
  mounted() {
    this.initTemplate();
  },
  watch: {
    formError(value) {
      if (value) {
        setTimeout(() => {
          this.formError = null;
        }, 5000);
      }
    }
  },
  methods: {
    ...mapActions(["actResetPassword"]),
    initTemplate() {
      // this.$refs.userEmail.focus();
    },
    resetPasswordCB() {
      // Check for form's validity
      if (!this.isFormValid()) return;
      this.showLoading = true;

      // If form in valid
      this.actResetPassword({
        email: this.userEmail
      })
        .then(response => {
          this.showLoading = false;
          // If error occured
          if (response.error) {
            // Clear the form
            this.userEmail = "";

            // Show password reset failed popup message
            this.formError = response.reason;
          } else {
            this.showSuccessMessage =
              "We have sent you an email with reset instructions";
            this.header = "Success";
          }
        })
        .catch(error => {
          this.showLoading = false;
          // Show password reset failed popup message
          this.formError = error;
        });
    },
    isFormValid() {
      return this.validateEmailInput();
    },
    validateEmailInput() {
      let maxChar = 64;
      // validateEmail method was defined in Utility mixin
      if (!this.userEmail) {
        this.userEmailError = "Please enter Email";
        document.getElementById("userEmail").classList.add("formError");
        return false;
      } else if (!this.validateEmail(this.userEmail)) {
        this.userEmailError =
          "Invalid Email Id.Please enter in format xxx@yyy.com";
        document.getElementById("userEmail").classList.add("formError");
        return false;
      } else if (this.userEmail.length > maxChar) {
        this.userEmailError = `E-mail must be less than ${maxChar} characters`;
        document.getElementById("userEmail").classList.add("formError");
        return false;
      } else {
        this.userEmailError = "";
        document.getElementById("userEmail").classList.remove("formError");
        return true;
      }
    }
  },
  mixins: [Utility]
};
</script>

<style lang="scss" scoped>
@import "~sass/modules/variables";

.rest-popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: $clr-dark-hlt;
  z-index: 8888;
  overflow-y: scroll;
  .popup-box {
    position: fixed;
    background-color: #fff;
    z-index: 8889;
    // padding: 15px 20px;
    border-radius: 4px;
    min-width: 320px;
    top: 45%;
    left: 50%;
    transform: translate(-50%, -50%);
    // max-height: 80%;
    // overflow-y: auto;
  }
  .popup-form {
    margin-top: 10px;
  }
  .box-header {
    // margin-bottom: 40px;
    padding: 20px;
    // -webkit-box-shadow: 0 6px 12px -8px black;
    //  -moz-box-shadow: 0 6px 12px -8px black;
    //       box-shadow: 0 6px 12px -8px black;
    h6 {
      text-align: center;
      width: 95%;
      float: left;
      text-transform: uppercase;
      font-weight: 600;
      color: black;
      font-size: 25px;
    }
    .header-close {
      position: relative;
      cursor: pointer;
      float: right;
      width: 15px;
      top: 5px;
    }
  }
  .popup-message {
    text-align: center;
    margin: 1em;
    display: block;
  }
}
.session-exp-popup {
  margin: 0 20%;
}
.enter-your-email-id {
  margin: 10% 0;
  color: rgba(33, 33, 33, 1);
  font-size: 17px;
  line-height: 20px;
  font-family: "ProximanovaRegular";
}
.email-adress-label {
  color: #212121;
  font-family: "ProximanovaBold";
  font-size: 18px;
  line-height: 22px;
  letter-spacing: 0.17px;
}
.email-address {
  margin: 2% 0 0 0;
  border-bottom: 2px solid #e2e0e0;
}
.reset-btn {
  margin: 10% 0;
}
.success-style {
  text-align: center;
  color: green;
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Popups/ResetPassword.vue